import { API } from '@config';
import { WorkOrdersResidentTable } from '@src/types/WorkOrdersResidential';

export const getWorkOrdersResidential = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/residential-fn-p-work-orders?populate=File&sort=id%3Adesc`, options);
  const data: WorkOrdersResidentTable = await response.json();

  return data;
};
